export default __webpack_public_path__ + "static/media/0x8d1566569d5b695d44a9a234540f68d393cdc40d.71012e6b.jpg";